import { defaults, isString, isEmpty, startsWith } from 'lodash';

function addBaseUrlToValue(value, url) {
    if (value) {
        if (isEmpty(url) || !isString(url)) {
            return value;
        }

        if (startsWith(value, '/')) {
            return `${url}${value}`;
        }

        return `${url}/${value}`;
    }
    return '';
}

class ContentZone {
    constructor(cz, imageServerUrl) {
        const contentZone = { ...cz };

        if (contentZone && contentZone.hasImage) {
            if (!startsWith(contentZone.image, 'http')) {
                const result = addBaseUrlToValue(contentZone.image, imageServerUrl);
                contentZone.image = result;
            }
        }

        defaults(this, contentZone);
    }

    isEqual(contentZone) {
        return this.name === contentZone.name;
    }

    getValue() {
        if (this.hasImage) {
            return this.image;
        }
        if (this.hasHTML) {
            return this.html;
        }
        if (this.hasText) {
            return this.text;
        }
        if (this.hasLink) {
            return this.link;
        }

        return '';
    }

    getImage() {
        return this.image;
    }

    getHTML() {
        return this.html;
    }

    getText() {
        return this.text;
    }

    getLink() {
        return this.link;
    }
}

export { addBaseUrlToValue };
export default ContentZone;
